import { render, staticRenderFns } from "./ListBaseFretebasView.vue?vue&type=template&id=1df069e2&"
import script from "./ListBaseFretebasView.vue?vue&type=script&lang=ts&"
export * from "./ListBaseFretebasView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports